import {useState} from 'react'
import RegionDetailsForm from './RegionDetailsForm';
import RegionDetailsList from './RegionDetailsList';

const RegionDetails = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <RegionDetailsForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <RegionDetailsList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default RegionDetails
